<template>
  <div
    class="study-pagearea primary-page"
    v-wechat-title="$route.meta.title = seriesData.name"
  >
    <div class="mask-zone">
      <img :src="seriesData.teacher_image" class="cover">
    </div>
    <div class="series-data-wrapper">
      <div class="name">{{ seriesData.name }}</div>
      <div class="summary">{{ seriesData.summary }}</div>
      <div class="white-box">
        <div class="dates">
          <span>{{ seriesData.training_date | dateStr }}至{{ seriesData.finish_date | dateStr }}</span>
          <span v-if="seriesData.finish_date">   共{{ dateCount(seriesData.training_date, seriesData.finish_date) }}天</span>
        </div>
        <div class="cover-zone">
          <img :src="seriesData.teacher_image" class="cover-img">
          <div class="camp-num-box"><span>第{{ seriesData.camp_num + 1 }}期</span></div>
        </div>
        <div class="data-box">
          <div class="left-box">
            <div class="box study-range">
              <div class="per"><span>{{ seriesData.learning_process }}%</span></div>
              <div class="subs">学习进度</div>
            </div>
            <div class="box study-hours">
              <div class="per">
                <template v-if="secondsToHM(seriesData.total_time, 'h')">
                  <span>{{ secondsToHM(seriesData.total_time, 'h') || 0 }} </span>小时
                </template>
                <template v-if="!(secondsToHM(seriesData.total_time, 'h') && !secondsToHM(seriesData.total_time, 'm'))">
                  <span>{{ secondsToHM(seriesData.total_time, 'm') || 0 }} </span>分钟
                </template>
                </div>
              <div class="subs">学习时长</div>
            </div>
          </div>
          <div class="right-box" @click.stop="jumpReportPage">查看报告</div>
        </div>
        <div class="join-wx-club">
          <div class="box">
            <div class="img-box" :style="wxClubCoverStyle">
              <div class="cover-box">
                <img class="head-img" :src="userViewData.portrait" alt="">
              </div>
            </div>
            <div class="text-box" @click.stop="onWxclubClick">
              <div class="wxclub-name">点击添加“学习助手”</div>
              <div class="guide">进群参加互动</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="plan-wrapper">
      <div class="header">
        <div class="title">学习计划</div>
        <div class="my-clock" @click.stop="jumpMyClock">我的打卡</div>
      </div>
      <div class="body">
        <div class="admission-letter" @click.stop="getAdmissionLetterEvent">入学通知书</div>
        <div class="modules-wrapper" v-if="seriesData.learn_plan && seriesData.learn_plan.modules.length">
          <div v-for="(item, index) in seriesData.learn_plan.modules" class="box" :class="{ 'if-preview': item.type === 0 }" :key="index">
            <camp-learn-plan-module :module-mode="Boolean(seriesData.learn_plan.module_mode)" :training-date="seriesData.training_date" :series-id="+seriesData.id" :data="item" :is-paid="userViewData.is_paid"></camp-learn-plan-module>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗：入学通知书 -->
    <van-overlay class-name="admission-letter-dialog" z-index="1001" :show="showAdmissionLetterDia">
      <div class="dialog-main">
        <i class="close-btn" @click="showAdmissionLetterDia = false"></i>
        <img class="porter" :src="admissionLetterSrc" alt="">
        <div class="tips">长按保存图片，可分享给好友</div>
      </div>
    </van-overlay>

    <!-- 弹窗：加入学习群 -->
    <van-overlay class-name="join-wxclub-dialog" z-index="1001" :show="showWxclubDialog">
      <div class="dialog-main">
        <i class="close-btn" @click="showWxclubDialog = false"></i>
        <div class="title">扫码申请加入专属学习群</div>
        <img class="wxclub-img" :src="seriesData.after_sale_image" alt="">
        <div class="tips">长按识别二维码</div>
      </div>
    </van-overlay>

  </div>
</template>

<script>
import { Overlay, Toast, Dialog } from 'vant';
import Cookies from 'js-cookie';
import campLearnPlanModule from '@/components/campLearnPlanModule/campLearnPlanModule.vue';
import WxShare from '@/common/js/wxShare';

import {
  // eslint-disable-next-line camelcase
  getCampSeriesLearnDetail_v4_0,
  getJoinCard,
  getUserViewData,
} from '@/api/api';

const WX_CLUB_IMGS = [
  'http://alcdn.yojiang.cn/upload/test/123/1623054169.png',
  'http://alcdn.yojiang.cn/upload/test/123/1623054214.png',
  'http://alcdn.yojiang.cn/upload/test/123/1623054229.png',
  'http://alcdn.yojiang.cn/upload/test/123/1623054245.png',
  'http://alcdn.yojiang.cn/upload/test/123/1623054257.png',
  'http://alcdn.yojiang.cn/upload/test/123/1623054270.png'
];
export default {
  components: {
    campLearnPlanModule,
    [Overlay.name]: Overlay
  },
  data() {
    return {
      showAdmissionLetterDia: false,
      admissionLetterSrc: null,
      showWxclubDialog: false,
      seriesId: 0,
      seriesData: {},
      userViewData: {},
    };
  },
  computed: {
    wxClubCoverStyle() {
      const random = Math.floor(Math.random() * 6); // 0~5随机数字
      const bgSrc = WX_CLUB_IMGS[random];
      return `background: url(${bgSrc}) center no-repeat;background-size: cover;`;
    }
  },
  filters: {
    dateStr(time) {
      let res = '';
      if (time) {
        res = time.replace(/-/g, '.');
        res = res.substr(0, 10);
      }
      return res;
    },
    secondsToMinutes(seconds) {
      return Math.floor(seconds / 60);
    },
  },
  async created() {
    const userId = Cookies.get('user_id');

    if (!userId) {
      this.$router.replace({
        path: '/login',
        query: { redirect: `/camp-learning/${this.$route.params.series_id}` },
      });
      return;
    }

    /**
     * @description 用户是否购买了课程，没有跳转到购买页
     * @param {number} courseId 课程ID
     * @returns {promise} 买了resolve(true)，反之resolve(false)
     */
    const isBuyCourse = courseId => new Promise((resolve) => {
      getUserViewData(courseId).then((res) => {
        const isBuy = res.data.is_paid;

        if (!isBuy) {
          Dialog.confirm({
            title: '请先购买课程',
            showCancelButton: false,
          })
            .then(() => {
              // window.location.href = `${window.location.origin}/classroom/camp/${courseId}`;
              this.$router.replace(`/camp/${courseId}`);
            })
            .catch(() => {});
          resolve(false);
        }

        resolve(true);
      });
    });

    this.seriesId = this.$route.params.series_id;

    const isBuy = await isBuyCourse(this.seriesId);

    if (!isBuy) {
      return;
    }

    this.queryCampSeriesDetail();
    this.queryUserViewData();
  },
  methods: {
    queryCampSeriesDetail() {
      getCampSeriesLearnDetail_v4_0(this.seriesId).then((res) => {
        res.learn_plan.modules.forEach((item) => {
          item.contents.forEach((content) => {
            content.study_process_list = this.makeStudyStatusArr(content.total_study, content.completed_study);
          });
        });

        this.seriesData = res;

        // 设置微信分享内容
        WxShare({
          title: res.name,
          desc: res.summary,
          link: window.location.href,
          imgUrl: res.teacher_image
        });
      });
    },
    queryUserViewData() {
      getUserViewData(this.seriesId).then((res) => {
        this.userViewData = res.data;

        if (this.$route.query.show_admission && this.userViewData.is_paid) {
          this.getAdmissionLetterEvent();
        }
      });
    },
    // eslint-disable-next-line camelcase
    dateCount(training_date, finish_date) {
      let trainingDate = training_date.replace(/-/g, '/');
      let finishDate = finish_date.replace(/-/g, '/');
      trainingDate = new Date(trainingDate);
      finishDate = new Date(finishDate);
      return (finishDate.getTime() + 1000 * 60 * 60 * 24 - trainingDate.getTime()) / (1000 * 60 * 60 * 24);
    },
    getAdmissionLetterEvent() {
      if (!this.userViewData.is_paid) {
        Toast('请先购买课程~');
        return;
      }
      Toast.loading({
        duration: 0,
        message: '正在生成...',
        forbidClick: true,
      });
      getJoinCard(this.seriesId).then((res) => {
        this.admissionLetterSrc = res.url;
        this.showAdmissionLetterDia = true;
        Toast.clear();
      });
    },
    onWxclubClick() {
      if (!this.userViewData.is_paid) {
        Toast('请先购买课程~');
        return;
      }
      this.showWxclubDialog = true;
    },
    makeStudyStatusArr(totalStudy, completedStudy) {
      const arr = [];
      if (!totalStudy) {
        return arr;
      }

      // 完成了必修课则显示评论入口
      if (completedStudy) {
        this.showComment = true;
      }

      for (let i = 1; i <= totalStudy; i++) {
        if (completedStudy >= i) {
          arr.push({
            finished: true
          });
        } else {
          arr.push({
            finished: false
          });
        }
      }
      // for (let i = 1; i <= totalStudy; i++) {
      //   const item = {
      //     finished: false
      //   };
      //   for (let j = completedStudy; j >= 1; j--) {
      //     item.finished = true;
      //     // eslint-disable-next-line no-plusplus
      //     completedStudy--;
      //     break;
      //   }
      //   arr.push(item);
      // }
      return arr;
    },
    jumpMyClock() {
      this.$router.push({
        path: `/my-clock-in?courseId=${this.seriesId}`
      });
    },
    jumpReportPage() {
      this.$router.push({
        name: 'camp-learning-report',
        params: {
          series_id: this.seriesId
        }
      });
    },
    secondsToHM(seconds, type = 'h') {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      if (type === 'h') {
        return hours;
      }
      return minutes;
    },
  },
  beforeDestroy() {
    // 页面销毁的时候重置分享内容
    WxShare();
  }
};
</script>

<style lang="stylus" scoped>
@import './../../common/stylus/variable.styl';
@import './../../common/stylus/mixin.styl';
.study-pagearea {
  position relative
  // background: #F6F7FA;
}
.mask-zone {
  position absolute
  width 100%
  height 226px
  overflow: hidden;
  .cover {
    width: 100%;
    height: 100%;
    object-fit: cover;
    margin: auto;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50%;
    filter: blur(40px);
    -webkit-transform: scale(1.5);
    transform: scale(1.5);
  }
  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.4);
  }
}
.series-data-wrapper {
  position relative
  margin-bottom 8px
  .name {
    padding 30px 16px 6px 128px
    font-size: 20px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 32px;
    no-wrap()
  }
  .summary {
    padding 0 16px 16px 128px
    font-size: 12px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.8);
    line-height: 18px;
    no-wrap()
  }
  .white-box {
    position relative
    padding 0 16px
    background: #FFFFFF;
    border-radius: 12px 12px 0px 0px;
    .dates {
      // padding 20px 0 31px 128px
      padding 18px 0 29px 128px
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      line-height: 16px;
      &::before {
        content ''
        position absolute
        top 20px
        left 128px
        display block
        width 12px
        height 12px
        background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAYCAMAAADTXB33AAAAyVBMVEUAAAAAAAD///9/f3+/v7+VlZWSkpKZmZmSkpKZmZmWlpacnJyYmJifn5+ampqdnZ2ZmZmenp6ZmZmYmJiYmJibm5uYmJibm5uampqampqZmZmbm5uampqYmJibm5uampqbm5uZmZmZmZmZmZmZmZmYmJiZmZmbm5uZmZmYmJiZmZmampqZmZmZmZmZmZmampqZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmYmJiZmZmZmZmampqZmZntjUxXAAAAQnRSTlMAAQECBAwODxUeIiQlJSYnKCotLzQ9Q0VHSUtSYGFpamtxe32CiIyRmZqssLe8vr/DytDX29/h6Ort8fL0+Pv9/v72iS1hAAAA/klEQVQoz6WRyVLDMBBEO2CbJWAWE7GELGAgXgCbCIKFSaL0/38UB0u2ilRxoU+jeqWu7hngb+1dXe7befcw3OnI3Tf5ddHM4YJcDC25JZkfiETWtUzE2Qu5vjbonZv744JGxckj+dYQb8OHgWIVR74fxRXV4IlL8+vz+UgxC5pHkFGFrx82xWnBrAegLAH0MhbnU5tDsAoAgASAoKJow6eM0SHETFskGbkoomxRTd8gcnkDn/UWKtdbyBoauYY2hlHMBL/Dm9JueJjKgKnsWPQVc7uonKrv2s/YrZczl4y1ntujzLUed8Rb6QlEKutapgITvfI6Nhq6HsMR/qEfauUqel5hgwYAAAAASUVORK5CYII=') center no-repeat
        background-size cover
      }
    }
    .cover-zone {
      position absolute
      left 16px
      top -78px
      width: 100px;
      height: 125px;
      // background: #FFC650;
      border-radius: 6px;
      overflow hidden
      .cover-img {
        width 100%
        height 100%
        object-fit cover
      }
      .camp-num-box {
        position: absolute;
        right: 4px;
        bottom: 4px;
        padding: 4px 8px
        font-size: 20px;
        color: #191919;
        background: rgba(255,255,255,0.85);
        border-radius: 4px;
        transform: scale(0.5);
        transform-origin: 100% 100%;
      }
    }
    .data-box {
      display flex
      align-items center
      justify-content space-between
      padding-bottom 24px
      .left-box {
        display: flex;
        align-items: center;
        .box {
          .per {
            span {
              font-size: 20px;
              font-family: DINAlternate-Bold, DINAlternate;
              font-weight: bold;
            }
            font-size: 14px;
            font-weight: 400;
            color: $color-text;
            text-align left
          }
          .subs {
            margin-top 6px
            font-size: 12px;
            font-weight: 400;
            color: #999999;
            line-height: 12px;
          }
          &:not(:last-child) {
            margin-right 48px
          }
        }
      }
      .right-box {
        width: 80px;
        height: 26px;
        border-radius: 14px;
        border: .5px solid #DADADA;
        font-size: 12px;
        font-weight: 400;
        color: #999999;
        line-height: 26px;
        text-align center
      }
    }
    .join-wx-club {
      padding-bottom 16px
      .box {
        display flex
        align-items center
        width: 100%;
        padding 5px 40px 4px 10px
        background: #FFF6EF url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAIVBMVEUAAACVlZWbm5uZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZntH403AAAACnRSTlMADCGqrK2xw9nhFCoieAAAAC5JREFUGNNjYMAAzIlIHI7lAggO06xCJClNGks5IHMCsCtDMYCKEijeRgkQKAAAqyATdyRf7PoAAAAASUVORK5CYII=') center right 12px no-repeat;
        background-size 12px
        border-radius: 6px;
        border: 1px solid #FFC59A;
        .img-box {
          width: 45px;
          height: 45px;
          margin-right 9px
          .cover-box {
            display flex
            align-items center
            justify-content center
            width 100%
            height 100%
            .head-img {
              width: 13px;
              height: 13px;
              border-radius: 1px;
              object-fit cover
            }
          }
        }
        .text-box {
          flex 1
          overflow hidden
          .wxclub-name {
            width 100%
            font-size: 14px;
            font-weight: 500;
            color: #191919;
            line-height: 24px;
            no-wrap()
          }
          .guide {
            margin-top 3px
            font-size: 12px;
            font-weight: 400;
            color: #999999;
            line-height: 12px;
          }
        }

      }
    }
  }
}
.plan-wrapper {
  padding 0 16px 48px
  background #fff
  .header {
    display flex
    align-items center
    justify-content space-between
    width 100%
    padding 22px 0 10px
    border-bottom .5px solid #E7E7E7
    .title {
      font-size: 20px;
      font-weight: 500;
      color: #191919;
      line-height: 24px;
    }
    .my-clock {
      padding-left 18px
      background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAXVBMVEUAAAD/fwD/qlX/kkn/kkn/k0X/lEL/nEL/lkb/mET/lkX/l0T/l0X/lkX/lkX/l0X/lkb/lUT/l0X/lkX/l0X/lkX/lkX/lkX/lkX/lkX/l0b/lkX/lkX/lkT/lkX9KGSBAAAAHnRSTlMAAgMHDhofH0lPVVZzeoWJlqSmqrXd3uDh8PL4/f60L6zPAAAAoUlEQVQ4y9WTyQ6DMAxE2ZeyY3bC/P9ncnFQCU4FVS+dgzXSPFkjxXGc2/KzSNso8wWgwqDtgEoACNAWoHMW5A3RhI1YGyaiJg90HvYQ1YcMtLCoZWC2AfPRyab/Al6i3gD5fR8C5VIa0wAWLMZ8uuG3JUXgVO+rDZ86KLhS7kKxG5FIQIKRXYG1o4u6FQUDXq2kY1C1d2yL0+s1pPG9T78DMrwu0zuxaXAAAAAASUVORK5CYII=') center left 0 no-repeat
      background-size 16px
      font-size: 14px;
      font-weight: 400;
      color: #FF9645;
      line-height: 20px;
    }
  }
  .body {
    .admission-letter {
      position relative
      width: 100%;
      height: 48px;
      margin-top: 10px;
      padding-left: 36px;
      background: #F6F7FA url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAA2FBMVEUAAAAAAAAAAAAAAAAaGhoVFRUcHBwXFxcWFhYUFBQZGRkWFhYbGxsaGhoaGhoWFhYaGhoZGRkZGRkaGhoaGhoWFhYaGhoYGBgYGBgXFxcbGxsaGhoZGRkaGhoaGhoZGRkYGBgZGRkYGBgaGhoZGRkYGBgYGBgZGRkZGRkZGRkZGRkZGRkYGBgZGRkZGRkaGhoZGRkZGRkZGRkZGRkZGRkYGBgZGRkZGRkZGRkZGRkaGhoZGRkYGBgYGBgYGBgZGRkZGRkZGRkZGRkZGRkYGBgZGRkZGRkZGRmN8MO4AAAAR3RSTlMAAQMFCgwSFhcaHyMmJyguMTM0OjtERElLTExNUXZ3fH+EiIqOkpWYmZqbnJ6kpamwt8HDxMjM19ja3OHl8fLz9PX29/z9/ptkXNEAAAEBSURBVDjLvZPHdsIwEEWHElMDBFOTQETv2HQIxaHp/f8fZcGRLesoZMPhrubN3KOZjYieRbCyucDjsqkE/cIYKmPfPAenFJJyqOQgJwtVtJSdLVTlyMAUQekwMKLPxfLGMKAX+uK+U1gvvBTLN17/WPHvDZl2t9v5uCOMAGB1R0h8McZMrWAMNDf0DTe8/wC24ZsbNuCURfrGGjjUI+44Uj8Aa2xF5giYE45jM0ZERLHmEXxiErgQACLK2hznXiFV6J3B7axoewJR2roCAK5WWm7LVbI2XU1rSbUtVT4eKewR18zj2IvSwjz/ppKfw3LdHXTsvHejjdlSZdaIPuvX/gLBJkIlDKjIIwAAAABJRU5ErkJggg==') center left 16px no-repeat;
      background-size 16px
      border-radius: 4px;
      font-size: 14px;
      font-weight: 400;
      color: #191919;
      line-height: 48px;
      text-align: left;
      &::after {
        content ''
        display block
        position absolute
        top 18px
        right 16px
        width 12px
        height 12px
        background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAIVBMVEUAAACVlZWbm5uZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZntH403AAAACnRSTlMADCGqrK2xw9nhFCoieAAAAC5JREFUGNNjYMAAzIlIHI7lAggO06xCJClNGks5IHMCsCtDMYCKEijeRgkQKAAAqyATdyRf7PoAAAAASUVORK5CYII=') center no-repeat;
        background-size 12px
      }

    }
    .modules-wrapper {
      .box {
        &.if-preview {
          position relative
          margin-top 17px
          &::after {
            content ''
            position absolute
            left 12px
            top -4px
            display block
            width 54px
            height 24px
            background url(../../common/images/catalog_icon_preview@2x.png) center no-repeat
            background-size cover
          }
        }
      }
    }
  }
}
.admission-letter-dialog {
  display flex
  align-items center
  justify-content center
  background rgba(0, 0, 0, .6)
  .dialog-main {
    position absolute
    display flex
    flex-direction column
    align-items: flex-end;
    // justify-content: center;
    width 100%
    height 100%
    .close-btn {
      display block
      width 40px
      height 40px
      margin-top 12px
      margin-bottom 8px
      background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAYFBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////a2trm5ubo6Ojt7e35+fn+/v7///9sAo1oAAAAGXRSTlMABRIWGSQlUFdma3WNj7bIztvr8fP0+Pz+yTO4JAAAASlJREFUSMetlsmSgzAMRDsQlrAvCdhA6P//yxwmQxhjA0pN38Cvq2xJlgyY8uO8qJuua+oij30cyEtKxZVUmXg7+DV7cKNHdnXgl/ROq+7pxcYHFZ2qgi0ftdxRG5n8reeu+pvBKx5I/XFEPQ/Vr3YVtjyhNlziWfGUqt/opjyp9J3fJV/PYZpNaJ6G55LBn5xny+Kg9Wg45lHrYfnKAMD71M+kTcc8aq2nT115ABJjee3Y/EgAlHQCG54l4Cu6HFueyke8PeQbsvBkjJwOh5VnjoJ2h51ngZp2h51njYZ2h51ng44uh41nJzeItyQ+tDis4sSJS0NcfOLyll8g8RUVNwF5mxE3MnmrPNuMg+/bvXygyEeWfCgC4d7YDf9jsMufDl88Ts48f16YZdJeyECrsAAAAABJRU5ErkJggg==') bottom 0 center no-repeat
      background-size 24px
    }
    .porter {
      display block
      height 78%
      object-fit contain
      margin 0 auto
    }
    .tips {
      width 100%
      margin-top 12px
      font-size: 15px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 15px;
      text-align center
    }
  }
}
.join-wxclub-dialog {
  display flex
  align-items center
  justify-content center
  background rgba(0, 0, 0, .6)
  .dialog-main {
    position relative
    width: 78.667%
    max-width: 295px;
    padding 32px 0
    background: #FFFFFF;
    border-radius: 8px;
    .title {
      font-size: 18px;
      font-weight: 500;
      color: $color-text;
      line-height: 24px;
      text-align center
    }
    .close-btn {
      position absolute
      top 0
      right 0
      display block
      width 40px
      height 40px
      background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAGFBMVEUAAAD////f39/c3Nzb29vb29va2tra2trHZ7SVAAAAB3RSTlMAAQhnd5ydCk3pvAAAAJ1JREFUOMvlkrsNwzAMRI9JBlAj1xkhRQYIkAlcqXblCeRbP4Whjy3eAg4r3kkPBMgD/qFu39CEvZ+1f3BuD5Gf2t+ZK2KJL3RibkAOPV5U/+cgj0DTJ6AZZ6A4A1CsEdg9B9gRDwAiswcAlugCQKQLABO5eL6t5BZcwB9uicvkTY/cgq0jIleilijXrg4lT6vCIOMjAycjKkN95foBh0Q6tnE+6y4AAAAASUVORK5CYII=') center no-repeat
      background-size 24px
    }
    .wxclub-img {
      width 100%
      height 216px
      padding: 5%;
      object-fit: contain;
    }
    .tips {
      font-size: 16px;
      font-weight: 400;
      color: #999999;
      line-height: 16px;
      text-align center
    }
  }
}

</style>
